import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Container, H2, Subtitle1, H4, Body1, Button, Share, EmailOptin, CheckSubscription, CustomIcon } from '../../../cdl-react-components/components'
import EditButton from '../../../Utilities/EditButton'
import { DJANGO_URL } from '../../../cdl-react-components/utilities/constants'
import Link from '../../../Utilities/Link'
import SampleButton from '../../../Utilities/SampleButton'
import Thumbnails from '../../../Utilities/Thumbnails'
import { formatBytes } from '../../../cdl-react-components/utilities/files'
import { getArticleFeatureImage, getArticleMapImage, formatResultsItemDate } from '../../../../utilities'

class ArticleDesktop extends Component {

    renderArticleButton = (article, authenticated, user) => {
        if (!article.pdf)
            return null
        else if (new Date(article.publication_date) > new Date())
            return null
        else if (article['free_article'])
            // Free Article
            return (<Link className="btn btn--raised article__read-article-btn" href={this.props.link}>Free Article</Link>)
        else if (authenticated)
            // Logged in, Subscribed
            return (<Link className="btn btn--raised article__read-article-btn" href={this.props.link}>Read Article</Link>)
        else if (article.sample_article)
            // Sample Article
            return (<SampleButton href={this.props.sampleLink} type="Digest Article">Read Sample Article</SampleButton>)
        else if (user)
            // Logged in, Not subscribed
            return (<Link className="btn btn--raised article__read-article-btn" href="/subscribe" style={{ 'marginBottom': '25px' }}>Subscribe</Link>)
        else
            // Not logged in
            return (
                // <div className="flex flex--end">
                //     <Link className="btn article__read-article-btn" href="/subscribe">Subscribe</Link>
                    <Button className="article__read-article-btn" raised secondary onClick={this.props.handleLogin}>Login to Read Article</Button>
                // </div>
            )
    }

    renderArticleContents = article => {
        return (
            <div className="article__contents">
                <H4>Contents</H4>
                <table>
                    <tbody>
                        <tr>
                            <th>Article&nbsp;type:</th>
                            <td>{this.props.commaSeporate(article.article_type)}</td>
                        </tr>
                        {article.pdf && (
                            <Fragment>
                                <tr>
                                    <th>File&nbsp;size:</th>
                                    <td>{article.pdf_size_field ? formatBytes(article.pdf_size_field, 2) : null}</td>
                                </tr>
                                <tr>
                                    <th>Word&nbsp;count:</th>
                                    <td>{article.word_count}</td>
                                </tr>
                                <tr>
                                    <th>Table&nbsp;count:</th>
                                    <td>{article.table_count}</td>
                                </tr>
                                <tr>
                                    <th>Figure&nbsp;count:</th>
                                    <td>{article.figure_count}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td>
                                        <ul>
                                            {article.figure_types.map(x => (<li key={'article__contents__figure_type--' + x.id}><CustomIcon>check</CustomIcon>{x.name}</li>))}
                                        </ul>
                                    </td>
                                </tr>
                            </Fragment>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        const { article, authenticated, user } = this.props
        const authors = this.props.commaSeporateComponents(article.authors, 'authors')

        return (
            <Container id="article--desktop" className="content-layout--two-column">
                <div>
                    <div className="article__image" style={{ backgroundImage: `url(${getArticleFeatureImage(article)})`}} />
                    { authenticated ? 
                        (<Fragment>
                            {this.renderArticleButton(article, authenticated, user)}
                            {this.renderArticleContents(article)}
                            <hr />
                            <EmailOptin
                                message="Sign up to receive weekly email alerts from Canadian Discovery when there are new Discovery Digest articles, features or events."
                                successMessage="Sign-up Successful"
                                role="Mail-9-Articles" />
                         </Fragment>) :
                        (<Fragment>
                            {this.renderArticleContents(article)}
                            {this.renderArticleButton(article, authenticated, user)}
                            <hr />
                            <CheckSubscription
                                message="A subscription to the Discovery Digest is required to view this article. Enter your email below to find out if your company subscribes."
                                productName="Canadian Discovery's Discovery Digest"
                                shortProductName="the Discovery Digest"
                                role="CDD" />
                         </Fragment>)
                    }
                </div>
                <div>
                    <div className="article__heading">
                        <H2>{article.title} {<EditButton href={`${DJANGO_URL}/admin/content/article/${article.id}/change/`} />}</H2>
                        <Subtitle1>{article.subtitle}</Subtitle1>
                        <Body1>{authors}{authors.length > 0 && ' | '}{formatResultsItemDate(article)}</Body1>
                        <Body1 dangerouslySetInnerHTML={{ __html: article.synopsis }} />
                    </div>
                    <hr />                    
                    <div className="flex">
                        <div className="article__map-image" style={{ backgroundImage: `url(${getArticleMapImage(article)})`}} />
                        <table className="article__details-table">
                            <tbody>
                                <tr>
                                    <th>Play(s):</th>
                                    <td>{article.plays && article.plays.length ? this.props.commaSeporateComponents(article.plays, 'plays') : 'N/A'}</td>
                                </tr>
                                <tr>
                                    <th>Fluid(s):</th>
                                    <td>{article.fluids && article.fluids.length ? this.props.commaSeporateComponents(article.fluids, 'fluids') : 'N/A'}</td>
                                </tr>
                                <tr>
                                    <th>Area:</th>
                                    <td>{article.area}</td>
                                </tr>
                                <tr>
                                    <th>Operator(s):</th>
                                    <td>{article.operators && article.operators.length ? this.props.commaSeporate(article.operators) : 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <H4>Preview</H4>
                    <Thumbnails article={article} />
                    <hr />
                    <div className="flex flex--end">
                        <Share title={article.title} url={window.location.origin + window.location.pathname} />
                    </div>
                </div>
            </Container>
        )
    }
}

ArticleDesktop.propTypes = {
    article: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    user: PropTypes.object,
    link: PropTypes.object,
    sampleLink: PropTypes.object,
    commaSeporate: PropTypes.func.isRequired,
    commaSeporateComponents: PropTypes.func.isRequired
}

export default ArticleDesktop